var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.569,
    height: 24,
    viewBox: "0 0 16.569 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.876 -7.303)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.876 7.303)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.483)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.982 0.955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.916,66.1a.3.3,0,1,0,0,.6H162.9a.3.3,0,0,0,.3-.3V46.269a.3.3,0,0,0-.3-.3h-2.6a.3.3,0,1,0,0,.6h2.3V66.1Z",
    transform: "translate(-158.614 -45.967)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3,46.571a.3.3,0,0,0,0-.6H59.7a.3.3,0,0,0-.3.3V66.4a.3.3,0,0,0,.3.3h3.983a.3.3,0,0,0,0-.6H60V46.571Z",
    transform: "translate(-59.398 -45.967)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.745 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.479,41.415a1.009,1.009,0,0,0,1.008-1.008V38.359a.3.3,0,0,0-.3-.3H90.709a.3.3,0,0,0-.3.3v2.049a1.009,1.009,0,0,0,1.008,1.008Zm-7.468-1.008V38.661h7.872v1.747a.4.4,0,0,1-.4.4H91.415A.4.4,0,0,1,91.011,40.408Z",
    transform: "translate(-90.407 -38.057)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.938 16.824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.982,180.715a3.346,3.346,0,1,0-3.346,3.346A3.35,3.35,0,0,0,106.982,180.715Zm-6.089,0a2.743,2.743,0,1,1,2.743,2.743A2.746,2.746,0,0,1,100.893,180.715Z",
    transform: "translate(-100.289 -177.369)",
    fill: "#291b4a",
    opacity: 0.58
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.828 19.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.119,200.014a.3.3,0,0,0,.214-.088l1.429-1.429a.3.3,0,0,0-.427-.427l-1.215,1.215-.668-.668a.3.3,0,0,0-.427.427l.881.882A.3.3,0,0,0,117.119,200.014Z",
    transform: "translate(-115.935 -197.981)",
    fill: "#291b4a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 6.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.33,89.685a.3.3,0,1,0,0-.6h-2.689a.3.3,0,0,0,0,.6Z",
    transform: "translate(-123.339 -89.081)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.162 7.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.471,102.766a.3.3,0,0,0,0-.6H152.13a.3.3,0,0,0,0,.6Z",
    transform: "translate(-151.828 -102.162)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 7.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.939,102.766a.3.3,0,0,0,0-.6h-2.3a.3.3,0,0,0,0,.6Z",
    transform: "translate(-123.339 -102.162)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.291 5.065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.751,82.194a2.192,2.192,0,1,0-2.192,2.192A2.195,2.195,0,0,0,82.751,82.194Zm-3.78,0a1.588,1.588,0,1,1,1.588,1.588A1.59,1.59,0,0,1,78.971,82.194Z",
    transform: "translate(-78.367 -80.002)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.464 6.611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.928,94.288a.3.3,0,0,0,.214-.088l.887-.887a.3.3,0,0,0-.427-.427l-.674.673-.334-.334a.3.3,0,0,0-.427.427l.547.547A.3.3,0,0,0,88.928,94.288Z",
    transform: "translate(-88.079 -92.798)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 12.041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.33,138.368a.3.3,0,1,0,0-.6h-2.689a.3.3,0,0,0,0,.6Z",
    transform: "translate(-123.339 -137.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.162 13.621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.471,151.449a.3.3,0,0,0,0-.6H152.13a.3.3,0,0,0,0,.6Z",
    transform: "translate(-151.828 -150.845)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 13.621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.939,151.449a.3.3,0,0,0,0-.6h-2.3a.3.3,0,0,0,0,.6Z",
    transform: "translate(-123.339 -150.845)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.291 10.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.751,130.877a2.192,2.192,0,1,0-2.192,2.192A2.195,2.195,0,0,0,82.751,130.877Zm-3.78,0a1.588,1.588,0,1,1,1.588,1.588A1.59,1.59,0,0,1,78.971,130.877Z",
    transform: "translate(-78.367 -128.685)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.464 12.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.928,142.973a.3.3,0,0,0,.214-.088l.887-.887a.3.3,0,0,0-.427-.427l-.674.673-.334-.334a.3.3,0,0,0-.427.427l.547.547A.3.3,0,0,0,88.928,142.973Z",
    transform: "translate(-88.079 -141.482)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.982 0.955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.916,62.1a.3.3,0,1,0,0,.6H162.9a.3.3,0,0,0,.3-.3V42.269a.3.3,0,0,0-.3-.3h-2.6a.3.3,0,1,0,0,.6h2.3V62.1Z",
    transform: "translate(-158.614 -41.967)",
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3,42.571a.3.3,0,0,0,0-.6H59.7a.3.3,0,0,0-.3.3V62.4a.3.3,0,0,0,.3.3h3.983a.3.3,0,0,0,0-.6H60V42.571Z",
    transform: "translate(-59.398 -41.967)",
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.745 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.479,37.415a1.009,1.009,0,0,0,1.008-1.008V34.359a.3.3,0,0,0-.3-.3H90.709a.3.3,0,0,0-.3.3v2.049a1.009,1.009,0,0,0,1.008,1.008Zm-7.468-1.008V34.661h7.872v1.747a.4.4,0,0,1-.4.4H91.415A.4.4,0,0,1,91.011,36.408Z",
    transform: "translate(-90.407 -34.057)",
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.982 0.955)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.916,62.1a.3.3,0,1,0,0,.6H162.9a.3.3,0,0,0,.3-.3V42.269a.3.3,0,0,0-.3-.3h-2.6a.3.3,0,1,0,0,.6h2.3V62.1ZM162.6,42.39h-2.3a.121.121,0,1,1,0-.242h2.6a.121.121,0,0,1,.121.121V62.4a.121.121,0,0,1-.121.121h-3.984a.121.121,0,1,1,0-.242H162.6a.181.181,0,0,0,.181-.181V42.571A.181.181,0,0,0,162.6,42.39Z",
    transform: "translate(-158.614 -41.967)",
    fill: "#e54890"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3,42.571a.3.3,0,0,0,0-.6H59.7a.3.3,0,0,0-.3.3V62.4a.3.3,0,0,0,.3.3h3.983a.3.3,0,0,0,0-.6H60V42.571ZM60,62.277h3.681a.121.121,0,0,1,0,.242H59.7a.121.121,0,0,1-.121-.121V42.269a.121.121,0,0,1,.121-.121h2.6a.121.121,0,0,1,0,.242H60a.181.181,0,0,0-.181.181V62.1A.181.181,0,0,0,60,62.277Z",
    transform: "translate(-59.398 -41.967)",
    fill: "#e54890"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.745 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.557,40.07a.586.586,0,0,0,.585-.585V37.738a.181.181,0,0,0-.181-.181H94.088a.181.181,0,0,0-.181.181v1.747a.585.585,0,0,0,.585.585Zm-7.468-.585V37.738h7.872v1.747a.4.4,0,0,1-.4.4H94.492A.4.4,0,0,1,94.088,39.485Z",
    transform: "translate(-93.484 -37.134)",
    fill: "#e54890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.479,37.415a1.009,1.009,0,0,0,1.008-1.008V34.359a.3.3,0,0,0-.3-.3H90.709a.3.3,0,0,0-.3.3v2.049a1.009,1.009,0,0,0,1.008,1.008Zm-7.891-1.008V34.359a.121.121,0,0,1,.121-.121h8.476a.121.121,0,0,1,.121.121v2.049a.827.827,0,0,1-.826.826H91.415A.827.827,0,0,1,90.588,36.408Z",
    transform: "translate(-90.407 -34.057)",
    fill: "#e54890"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.938 16.824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.982,176.715a3.346,3.346,0,1,0-3.346,3.346A3.35,3.35,0,0,0,106.982,176.715Zm-6.089,0a2.743,2.743,0,1,1,2.743,2.743A2.746,2.746,0,0,1,100.893,176.715Z",
    transform: "translate(-100.289 -173.369)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.828 19.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.119,196.014a.3.3,0,0,0,.214-.088l1.429-1.429a.3.3,0,0,0-.427-.427l-1.215,1.215-.668-.668a.3.3,0,0,0-.427.427l.881.882A.3.3,0,0,0,117.119,196.014Z",
    transform: "translate(-115.935 -193.981)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.938 16.824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.637,179.793a2.924,2.924,0,1,0-2.924,2.924A2.927,2.927,0,0,0,109.637,179.793Zm-5.666,0a2.743,2.743,0,1,1,2.743,2.743A2.746,2.746,0,0,1,103.97,179.793Z",
    transform: "translate(-103.366 -176.446)",
    fill: "#ebe7f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.982,176.715a3.346,3.346,0,1,0-3.346,3.346A3.35,3.35,0,0,0,106.982,176.715Zm-6.512,0a3.165,3.165,0,1,1,3.165,3.165A3.169,3.169,0,0,1,100.47,176.715Z",
    transform: "translate(-100.289 -173.369)",
    fill: "#ebe7f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.827 19.313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.117,196.014a.3.3,0,0,0,.214-.088l1.429-1.429a.3.3,0,0,0-.427-.427l-1.215,1.215-.668-.668a.3.3,0,1,0-.427.427l.881.882A.3.3,0,0,0,117.117,196.014Zm-.967-1.269a.121.121,0,0,1,.171,0l.668.668a.181.181,0,0,0,.256,0l1.215-1.215a.121.121,0,0,1,.171.171L117.2,195.8a.121.121,0,0,1-.171,0l-.881-.882A.121.121,0,0,1,116.15,194.745Z",
    transform: "translate(-115.933 -193.982)",
    fill: "#ebe7f2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 6.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.33,85.685a.3.3,0,1,0,0-.6h-2.689a.3.3,0,0,0,0,.6Z",
    transform: "translate(-123.339 -85.081)",
    fill: "#f9b087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.162 7.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.471,98.766a.3.3,0,0,0,0-.6H152.13a.3.3,0,0,0,0,.6Z",
    transform: "translate(-151.828 -98.162)",
    fill: "#f9b087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 7.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.939,98.766a.3.3,0,0,0,0-.6h-2.3a.3.3,0,0,0,0,.6Z",
    transform: "translate(-123.339 -98.162)",
    fill: "#f9b087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.291 5.065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.751,78.194a2.192,2.192,0,1,0-2.192,2.192A2.195,2.195,0,0,0,82.751,78.194Zm-3.78,0a1.588,1.588,0,1,1,1.588,1.588A1.59,1.59,0,0,1,78.971,78.194Z",
    transform: "translate(-78.367 -76.002)",
    fill: "#f9b087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.464 6.611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.928,90.288a.3.3,0,0,0,.214-.088l.887-.887a.3.3,0,0,0-.427-.427l-.674.673-.334-.334a.3.3,0,1,0-.427.427l.547.547A.3.3,0,0,0,88.928,90.288Z",
    transform: "translate(-88.079 -88.798)",
    fill: "#f9b087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 12.041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.33,134.368a.3.3,0,1,0,0-.6h-2.689a.3.3,0,0,0,0,.6Z",
    transform: "translate(-123.339 -133.764)",
    fill: "#f9b087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.162 13.621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.471,147.449a.3.3,0,0,0,0-.6H152.13a.3.3,0,0,0,0,.6Z",
    transform: "translate(-151.828 -146.845)",
    fill: "#f9b087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 13.621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.939,147.449a.3.3,0,0,0,0-.6h-2.3a.3.3,0,0,0,0,.6Z",
    transform: "translate(-123.339 -146.845)",
    fill: "#f9b087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.291 10.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.751,126.877a2.192,2.192,0,1,0-2.192,2.192A2.195,2.195,0,0,0,82.751,126.877Zm-3.78,0a1.588,1.588,0,1,1,1.588,1.588A1.59,1.59,0,0,1,78.971,126.877Z",
    transform: "translate(-78.367 -124.685)",
    fill: "#f9b087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.464 12.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.928,138.973a.3.3,0,0,0,.214-.088l.887-.887a.3.3,0,1,0-.427-.427l-.674.673-.334-.334a.3.3,0,0,0-.427.427l.547.547A.3.3,0,0,0,88.928,138.973Z",
    transform: "translate(-88.079 -137.482)",
    fill: "#f9b087"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 6.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.33,85.685a.3.3,0,1,0,0-.6h-2.689a.3.3,0,0,0,0,.6Zm-2.81-.3a.121.121,0,0,1,.121-.121h2.689a.121.121,0,1,1,0,.242h-2.689A.121.121,0,0,1,123.52,85.383Z",
    transform: "translate(-123.339 -85.081)",
    fill: "#ff8639"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.162 7.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.471,98.766a.3.3,0,0,0,0-.6H152.13a.3.3,0,0,0,0,.6Zm-2.461-.3a.121.121,0,0,1,.121-.121h2.341a.121.121,0,0,1,0,.242H152.13A.121.121,0,0,1,152.009,98.464Z",
    transform: "translate(-151.828 -98.162)",
    fill: "#ff8639"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 7.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.939,98.766a.3.3,0,0,0,0-.6h-2.3a.3.3,0,0,0,0,.6Zm-2.419-.3a.121.121,0,0,1,.121-.121h2.3a.121.121,0,0,1,0,.242h-2.3A.121.121,0,0,1,123.52,98.464Z",
    transform: "translate(-123.339 -98.162)",
    fill: "#ff8639"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.291 5.065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.406,81.271a1.769,1.769,0,1,0-1.769,1.769A1.771,1.771,0,0,0,85.406,81.271Zm-3.357,0a1.588,1.588,0,1,1,1.588,1.588A1.59,1.59,0,0,1,82.048,81.271Z",
    transform: "translate(-81.444 -79.079)",
    fill: "#ff8639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.751,78.194a2.192,2.192,0,1,0-2.192,2.192A2.195,2.195,0,0,0,82.751,78.194Zm-4.2,0A2.011,2.011,0,1,1,80.559,80.2,2.013,2.013,0,0,1,78.548,78.194Z",
    transform: "translate(-78.367 -76.002)",
    fill: "#ff8639"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.463 6.611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.927,90.289a.3.3,0,0,0,.213-.088l.887-.887a.3.3,0,0,0-.427-.427l-.674.673-.334-.334a.3.3,0,1,0-.427.427l.547.547A.3.3,0,0,0,88.927,90.289Zm-.668-.849a.121.121,0,0,1,.206-.085l.334.334a.181.181,0,0,0,.256,0l.674-.673a.121.121,0,0,1,.171.171l-.887.887a.121.121,0,0,1-.171,0l-.547-.547A.119.119,0,0,1,88.259,89.44Z",
    transform: "translate(-88.077 -88.798)",
    fill: "#ff8639"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 12.041)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.33,134.368a.3.3,0,1,0,0-.6h-2.689a.3.3,0,0,0,0,.6Zm-2.81-.3a.121.121,0,0,1,.121-.121h2.689a.121.121,0,1,1,0,.242h-2.689A.121.121,0,0,1,123.52,134.066Z",
    transform: "translate(-123.339 -133.764)",
    fill: "#ff8639"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.162 13.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.471,147.449a.3.3,0,0,0,0-.6H152.13a.3.3,0,0,0,0,.6Zm-2.461-.3a.121.121,0,0,1,.121-.121h2.341a.121.121,0,0,1,0,.242H152.13A.121.121,0,0,1,152.009,147.147Z",
    transform: "translate(-151.828 -146.845)",
    fill: "#ff8639"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.722 13.621)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.939,147.449a.3.3,0,0,0,0-.6h-2.3a.3.3,0,0,0,0,.6Zm-2.419-.3a.121.121,0,0,1,.121-.121h2.3a.121.121,0,0,1,0,.242h-2.3A.121.121,0,0,1,123.52,147.147Z",
    transform: "translate(-123.339 -146.845)",
    fill: "#ff8639"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.291 10.945)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.406,129.954a1.769,1.769,0,1,0-1.769,1.769A1.771,1.771,0,0,0,85.406,129.954Zm-3.357,0a1.588,1.588,0,1,1,1.588,1.588A1.59,1.59,0,0,1,82.048,129.954Z",
    transform: "translate(-81.444 -127.762)",
    fill: "#ff8639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.751,126.877a2.192,2.192,0,1,0-2.192,2.192A2.195,2.195,0,0,0,82.751,126.877Zm-4.2,0a2.011,2.011,0,1,1,2.011,2.011A2.013,2.013,0,0,1,78.548,126.877Z",
    transform: "translate(-78.367 -124.685)",
    fill: "#ff8639"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.464 12.49)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.928,138.974a.3.3,0,0,0,.214-.088l.887-.887a.3.3,0,0,0-.427-.427l-.673.673-.334-.334a.3.3,0,1,0-.427.427l.547.547A.3.3,0,0,0,88.928,138.974Zm-.633-.935a.121.121,0,0,1,.171,0l.334.334a.181.181,0,0,0,.256,0l.673-.674a.121.121,0,0,1,.171.171l-.887.887a.121.121,0,0,1-.171,0l-.547-.547A.121.121,0,0,1,88.3,138.039Z",
    transform: "translate(-88.079 -137.483)",
    fill: "#ff8639"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/Step1.bd4d176458b84899d010c9d27846de56.svg";
export { ForwardRef as ReactComponent };